import styled from "@emotion/styled";
export const StyledSolutionsMenuComponent = styled.div`
  height: 100%;
  min-height: 0;

  .menu-section {
    display: flex;
    flex-direction: column;
    gap: 48px;
    flex: 1;
    min-width: 0;

    .links {
      display: flex;
      flex-direction: column;
      gap: 8px;

      &.company-links {
        gap: 16px;
      }

      .descriptive-link-block {
        width: 256px;
        align-items: flex-start;

        > img.icon {
          width: 20px;
          height: 20px;
          margin-top: 2px;
        }

        .details {
          .title {
            font-size: 13px;
            font-weight: 400;
            line-height: 24px;
            white-space: nowrap;
          }

          .description {
            font-size: 11px;
            font-weight: 400;
            line-height: 100%;
            white-space: nowrap;
          }
        }
      }

      .mini-link-item {
        width: 160px;
        height: 20px;
        color: #000000;

        .text {
          color: #000000;
        }
      }
    }

    .business-applications-links {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .descriptive-link-block {
        width: 256px;
        align-items: flex-start;

        > img.icon {
          width: 28px;
          height: 28px;
          margin-top: 0;
        }

        .details {
          .title {
            font-size: 13px;
            font-weight: 400;
            line-height: 24px;
            white-space: nowrap;
          }

          .description {
            font-size: 11px;
            font-weight: 400;
            line-height: 100%;
            white-space: nowrap;
          }
        }
      }
    }
  }
`;
